import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import PublicRoute from './components/common/PublicRoute';
import AdminRoute from './components/common/AdminRoute';
import InicioPage from './pages/Inicio/InicioPage';
import LoginPage from './pages/Login/LoginPage';
import RegistroPage from './pages/Registro/RegistroPage';
import AdminDashboardPage from './pages/Admin/AdminDashboardPage';
import SolicitudesPage from './pages/Admin/SolicitudesPage';
import SolicitudDetailPage from './pages/Admin/SolicitudDetailPage';
import AdminAplicacionesPage from './pages/Admin/AdminAplicacionesPage';
import AdminAplicacionDetailPage from './pages/Admin/AdminAplicacionDetailPage';
import AdminFertilizantesPage from './pages/Admin/AdminFertilizantesPage';
import AdminFertilizanteDetailPage from './pages/Admin/AdminFertilizanteDetailPage';
import AdminEncargadosPage from './pages/Admin/AdminEncargadosPage';
import AdminEncargadoProductoresPage from './pages/Admin/AdminEncargadoProductoresPage';
import AplicacionesPage from './pages/Aplicaciones/AplicacionesPage';
import NuevaAplicacionPage from './pages/Aplicaciones/NuevaAplicacionPage';
import EditarAplicacionPage from './pages/Aplicaciones/EditarAplicacionPage';
import AplicacionDetailPage from './pages/Aplicaciones/AplicacionDetailPage';
import FertilizantesPage from './pages/Fertilizantes/FertilizantesPage';
import NuevaFertilizantePage from './pages/Fertilizantes/NuevaFertilizantePage';
import FertilizanteDetailPage from './pages/Fertilizantes/FertilizanteDetailPage';
import PWAInstallPrompt from './components/pwa/PWAInstallPrompt';
import UpdateAvailableBanner from './components/pwa/UpdateAvailableBanner';
import OfflineSyncManager from './components/pwa/OfflineSyncManager';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        {/* Instalación PWA: no exige sesión (puede aparecer en /login).
            Sincronización offline: headless, solo actúa si hay ENCARGADO
            activo. Ninguno de los dos altera las rutas existentes. */}
        <UpdateAvailableBanner />
        <PWAInstallPrompt />
        <OfflineSyncManager />
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <InicioPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route
            path="/registro"
            element={
              <PublicRoute>
                <RegistroPage />
              </PublicRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboardPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/solicitudes"
            element={
              <AdminRoute>
                <SolicitudesPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/solicitudes/:id"
            element={
              <AdminRoute>
                <SolicitudDetailPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/aplicaciones"
            element={
              <AdminRoute>
                <AdminAplicacionesPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/aplicaciones/:id"
            element={
              <AdminRoute>
                <AdminAplicacionDetailPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/fertilizantes"
            element={
              <AdminRoute>
                <AdminFertilizantesPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/fertilizantes/:id"
            element={
              <AdminRoute>
                <AdminFertilizanteDetailPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/encargados"
            element={
              <AdminRoute>
                <AdminEncargadosPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/encargados/:id"
            element={
              <AdminRoute>
                <AdminEncargadoProductoresPage />
              </AdminRoute>
            }
          />
          <Route
            path="/aplicaciones"
            element={
              <ProtectedRoute>
                <AplicacionesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/aplicaciones/nueva"
            element={
              <ProtectedRoute>
                <NuevaAplicacionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/aplicaciones/:id/editar"
            element={
              <ProtectedRoute>
                <EditarAplicacionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/aplicaciones/:id"
            element={
              <ProtectedRoute>
                <AplicacionDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fertilizantes"
            element={
              <ProtectedRoute>
                <FertilizantesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fertilizantes/nueva"
            element={
              <ProtectedRoute>
                <NuevaFertilizantePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fertilizantes/:id"
            element={
              <ProtectedRoute>
                <FertilizanteDetailPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
